var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-card",
    { staticClass: "p-2", attrs: { "no-body": "" } },
    [
      _vm.treeItem.children && !_vm.treeItem.children.length
        ? _c(
            "div",
            { staticClass: "text-center my-5" },
            [
              _c("b-icon", {
                attrs: {
                  icon: "exclamation-circle-fill",
                  variant: "danger",
                  "font-scale": "2",
                },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "mt-2" }, [_vm._v("No layers found")]),
            ],
            1
          )
        : _c(_setup.getComponent(_vm.treeItem.type), {
            tag: "component",
            attrs: { "tree-item": _vm.treeItem },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }